import useAutoFetch from "v4/hooks/useAutoFetch";
import {generateUrl} from "v4/services/api.service";
import {RESET_PASSWORD_REQUEST, RESET_PASSWORD_REQUEST_FORM} from "v4/data/apiRoutes";
import useFetch from "v4/hooks/useFetch";
import jsonToFormData from "v4/utils/jsonToFormData";

export default function useResetPasswordRequest() {
    const {data} = useAutoFetch(generateUrl(RESET_PASSWORD_REQUEST_FORM), null, {notoken: true});
    const form = data?.['hydra:member'];

    const [{data: saveData, isLoading: isSaveLoading, errorData}, saveFetch] = useFetch();

    const onSubmit = (data) => {
        saveFetch({
            url: generateUrl(RESET_PASSWORD_REQUEST),
            config: {
                method: 'POST',
                body: jsonToFormData(data),
                notoken: true,
            }
        })
    }

    return {
        form,
        onSubmit,
        isSaveLoading,
        formErrors: errorData?.errors,
        errorMessages: errorData?.errors?.['_form']?.messages,
        successMessages: saveData?.successes,
    }
}
